var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 513,
    viewBox: "0 0 355 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1702_701328)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1702_701328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 80L210 276H0L105 80Z",
    fill: "url(#paint0_linear_1702_701328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 140.818C75.978 153.525 84.0174 164.78 95.8666 168.629C107.715 172.479 120.637 168.034 127.798 157.647C134.959 147.259 134.705 133.326 127.171 123.218L117.912 97.9825L91.0884 97.9825L81.8285 123.218C78.0465 128.271 75.9984 134.457 76.0001 140.818V140.818Z",
    fill: "#FFE792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 151.01C91 151.838 90.3284 152.51 89.5 152.51V152.51C88.6716 152.51 88 151.838 88 151.01L88 150.924C88 150.095 88.6716 149.424 89.5 149.424V149.424C90.3284 149.424 91 150.095 91 150.924L91 151.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 144.837C96 145.666 95.3284 146.337 94.5 146.337V146.337C93.6716 146.337 93 145.666 93 144.837L93 143.722C93 142.893 93.6716 142.222 94.5 142.222V142.222C95.3284 142.222 96 142.893 96 143.722L96 144.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5443 97H121.456L133 137H76L87.5443 97Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.764 96.4983C122.764 97.6029 121.868 98.4983 120.764 98.4983L88.9994 98.4983C87.8948 98.4983 86.9994 97.6029 86.9994 96.4983L86.9994 75.5346C86.9994 74.43 87.8948 73.5346 88.9994 73.5346L120.764 73.5346C121.868 73.5346 122.764 74.43 122.764 75.5346L122.764 96.4983Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.804 67.5016L113.961 67.5016C117.304 67.5016 120.014 70.3765 120.014 73.9224L89.7516 73.9224C89.7516 70.3765 92.4608 67.5016 95.804 67.5016Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 94.3198L106.5 94.3198L106.5 91.2913L123 91.2913L123 94.3198Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 86.7484L87.0002 86.7484L87.0002 80.6913L123 80.6913L123 86.7484Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.839 101.824C102.93 100.792 103.795 100 104.831 100H105.169C106.205 100 107.07 100.792 107.161 101.824L109.808 131.824C109.911 132.994 108.99 134 107.816 134H102.184C101.01 134 100.089 132.994 100.192 131.824L102.839 101.824Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.061 102.059C111.027 100.932 111.932 100 113.06 100H113.322C114.293 100 115.123 100.697 115.292 101.652L120.586 131.652C120.802 132.877 119.86 134 118.616 134H113.942C112.86 134 111.975 133.14 111.943 132.059L111.061 102.059Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.262 101.783C118.124 100.843 118.852 100 119.802 100V100C120.508 100 121.126 100.475 121.307 101.158L129.335 131.488C129.671 132.757 128.714 134 127.402 134H124.727C123.735 134 122.893 133.273 122.749 132.291L118.262 101.783Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7084 101.652C94.8771 100.697 95.7075 100 96.678 100H96.9403C98.0679 100 98.9726 100.932 98.9394 102.059L98.0571 132.059C98.0253 133.14 97.1396 134 96.058 134H91.3838C90.1402 134 89.1982 132.877 89.4143 131.652L94.7084 101.652Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6881 101.178C87.8719 100.484 88.5005 100 89.219 100V100C90.167 100 90.9027 100.827 90.7919 101.769L87.2078 132.234C87.0893 133.241 86.2357 134 85.2215 134H81.5983C80.2857 134 79.329 132.757 79.6649 131.488L87.6881 101.178Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: -276,
    width: 4,
    height: 344,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1702_701328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 80L355 276H145L250 80Z",
    fill: "url(#paint1_linear_1702_701328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 140.818C220.978 153.525 229.017 164.78 240.867 168.629C252.715 172.479 265.637 168.034 272.798 157.647C279.959 147.259 279.705 133.326 272.171 123.218L262.912 97.9825L236.088 97.9825L226.828 123.218C223.047 128.271 220.998 134.457 221 140.818V140.818Z",
    fill: "#FFE792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 151.01C236 151.838 235.328 152.51 234.5 152.51V152.51C233.672 152.51 233 151.838 233 151.01L233 150.924C233 150.095 233.672 149.424 234.5 149.424V149.424C235.328 149.424 236 150.095 236 150.924L236 151.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 144.837C241 145.666 240.328 146.337 239.5 146.337V146.337C238.672 146.337 238 145.666 238 144.837L238 143.722C238 142.893 238.672 142.222 239.5 142.222V142.222C240.328 142.222 241 142.893 241 143.722L241 144.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.544 97H266.456L278 137H221L232.544 97Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.764 96.4983C267.764 97.6029 266.868 98.4983 265.764 98.4983L233.999 98.4983C232.895 98.4983 231.999 97.6029 231.999 96.4983L231.999 75.5346C231.999 74.43 232.895 73.5346 233.999 73.5346L265.764 73.5346C266.868 73.5346 267.764 74.43 267.764 75.5346L267.764 96.4983Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.804 67.5016L258.961 67.5016C262.304 67.5016 265.014 70.3765 265.014 73.9224L234.752 73.9224C234.752 70.3765 237.461 67.5016 240.804 67.5016Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 94.3198L251.5 94.3198L251.5 91.2913L268 91.2913L268 94.3198Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 86.7484L232 86.7484L232 80.6913L268 80.6913L268 86.7484Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.839 101.824C247.93 100.792 248.795 100 249.831 100H250.169C251.205 100 252.07 100.792 252.161 101.824L254.808 131.824C254.911 132.994 253.99 134 252.816 134H247.184C246.01 134 245.089 132.994 245.192 131.824L247.839 101.824Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.061 102.059C256.027 100.932 256.932 100 258.06 100H258.322C259.293 100 260.123 100.697 260.292 101.652L265.586 131.652C265.802 132.877 264.86 134 263.616 134H258.942C257.86 134 256.975 133.14 256.943 132.059L256.061 102.059Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.262 101.783C263.124 100.843 263.852 100 264.802 100V100C265.508 100 266.126 100.475 266.307 101.158L274.335 131.488C274.671 132.757 273.714 134 272.402 134H269.727C268.735 134 267.893 133.273 267.749 132.291L263.262 101.783Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.708 101.652C239.877 100.697 240.707 100 241.678 100H241.94C243.068 100 243.973 100.932 243.939 102.059L243.057 132.059C243.025 133.14 242.14 134 241.058 134H236.384C235.14 134 234.198 132.877 234.414 131.652L239.708 101.652Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.688 101.178C232.872 100.484 233.5 100 234.219 100V100C235.167 100 235.903 100.827 235.792 101.769L232.208 132.234C232.089 133.241 231.236 134 230.222 134H226.598C225.286 134 224.329 132.757 224.665 131.488L232.688 101.178Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: -276,
    width: 4,
    height: 344,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 62,
    width: 42,
    height: 61,
    rx: 2,
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 112L170 113V93L177 75L167 71V112Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 75H199L189 71H167L177 75Z",
    fill: "#BACAD6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    transform: "matrix(1 0 0 -1 170 113)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 93H192L199 75H177L170 93Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.639 86.3334C181.469 86.3334 182.683 85.5125 183.398 83.8063L184.001 82.3676C184.716 80.6614 184.19 79.8406 182.36 79.8406C180.54 79.8406 179.326 80.6614 178.611 82.3676L178.008 83.8063C177.293 85.5125 177.819 86.3334 179.639 86.3334ZM180.053 85.3465C179.013 85.3465 178.78 84.8762 179.232 83.7971L179.827 82.3768C180.28 81.2978 180.907 80.8274 181.947 80.8274C182.987 80.8274 183.23 81.2978 182.777 82.3768L182.182 83.7971C181.73 84.8762 181.093 85.3465 180.053 85.3465ZM188.233 80.3663H188.863L189.23 79.4901H188.24C187.24 79.4901 186.552 79.9881 186.119 81.0211L185.945 81.4361H185.075L184.715 82.2938H185.585L183.938 86.2227H185.138L186.785 82.2938H188.015L188.375 81.4361H187.145L187.311 81.0395C187.516 80.5507 187.763 80.3663 188.233 80.3663ZM191.622 80.3663H192.252L192.619 79.4901H191.629C190.629 79.4901 189.94 79.9881 189.507 81.0211L189.333 81.4361H188.463L188.104 82.2938H188.974L187.327 86.2227H188.527L190.174 82.2938H191.404L191.763 81.4361H190.533L190.7 81.0395C190.904 80.5507 191.152 80.3663 191.622 80.3663Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.127 106.12C179.957 106.12 180.827 105.23 180.827 103.38V101.82C180.827 99.97 179.957 99.08 178.127 99.08C176.307 99.08 175.437 99.97 175.437 101.82V103.38C175.437 105.23 176.307 106.12 178.127 106.12ZM178.127 105.05C177.087 105.05 176.657 104.54 176.657 103.37V101.83C176.657 100.66 177.087 100.15 178.127 100.15C179.167 100.15 179.607 100.66 179.607 101.83V103.37C179.607 104.54 179.167 105.05 178.127 105.05ZM184.83 100.69C184.15 100.69 183.64 100.94 183.22 101.52L183.18 100.81H182.16V106H183.36V102.63C183.65 102.04 184.03 101.75 184.53 101.75C185.02 101.75 185.26 102.04 185.26 102.68V106H186.46V102.57C186.46 101.33 185.91 100.69 184.83 100.69Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1702_701328",
    x1: 105,
    y1: 80,
    x2: 105,
    y2: 276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1702_701328",
    x1: 250,
    y1: 80,
    x2: 250,
    y2: 276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1702_701328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 513,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1702_701328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 425,
    fill: "white",
    transform: "translate(0 -149)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1702_701328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 425,
    fill: "white",
    transform: "translate(145 -149)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOn);
export default __webpack_public_path__ + "static/media/LightOn.8ec1f228c06beff1cf8ef5149aa614ee.svg";
export { ForwardRef as ReactComponent };